import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return localStorage.getItem('token')
  // return Cookies.get(TokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  return localStorage.setItem('token', 'token')
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  return localStorage.removeItem('token')
}
